import axios from "axios";
import store from "@/store";
import router from "@/router";

const apiClient = axios.create({
    baseURL: process.env.VUE_APP_SERVICE_URL,
    withCredentials: false,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    }
})
apiClient.interceptors.request.use((config) => {
    config.headers["Authorization"] = `bearer ${store.getters['token']}`
    return config;
});

apiClient.interceptors.response.use(undefined, error =>{
    let path= '/serverError'

    if (error.message == "Network Error") {
        router.push(path);
    }
    return Promise.reject(error)
    })


export default {
    async registerUser(credentials) {

        let registerUser = {}

        try {
            registerUser = await apiClient.post('/Auth/Register', credentials)
        }
        catch (error) {
            registerUser.data = "User Exists"
            let err = error.message
            store.dispatch("registerError", err)
        }
        return registerUser
    },

    async loginUser(credentials) {

        let loginUser = {}

        try {
            loginUser = await apiClient.post('/Auth/Login', credentials)
        }
        catch (error) {
            loginUser.data = "Wrong credentials"
            let err = error.message
            store.dispatch("loginError", err)
        }
        return loginUser
    },

    async getCourses(language) {
        let allCourses
        try {
            allCourses = await apiClient.get('/Course/Courses', {
                params: {
                    language: language
                }
            });
        }
        catch (error) {
            console.error(error)
        }
        return allCourses;
    },
    async getTestsByCourse(id, language) {
        let tests
        try {
            tests = await apiClient.get('/Test/GetTestsByCourse', {
                params: {
                    id: id,
                    language: language
                }
            })
        } catch (error) {
            console.error(error)
        }
        return tests
    },

    async getTest(id, language) {
        let test
        try {
            test = await apiClient.get('/Test/GetTest', {
                params: {
                    id: id,
                    language: language
                }
            })
        } catch (error) {
            console.error(error)
        }
        return test
    },

    async postAnswers(testName, testLanguage, givenAnswers, testQuestionsIDs) {
        let postTestInfo
        try {
            postTestInfo = await apiClient.post('AnswersCheck/UploadAnswers', {
                givenAnswers: givenAnswers,
                testLanguage: testLanguage,
                testName: testName,
                testQuestionsIDs: testQuestionsIDs

            })
        } catch (error) {
            console.error(error)
        }
        return postTestInfo
    },

    async getResults(courseId) {
        let results 
        try {
            results = await apiClient.get('/Result/GetResults',{
                params: {
                    courseId: courseId,
                }
            })
        }
        catch(error) {
            console.error(error)
        }
        return results
    },
    async postResult(score, testName, courseName, courseId, testId, date) {
        let postRes
        try {
            postRes = await apiClient.post('/Result/UploadResult', {
                score: score,
                testName: testName,
                courseName: courseName,
                courseId: courseId,
                testId: testId,
                date: date
            })
        }
        catch (error) {
            console.error(error)
        }
        return postRes
    },

}